module.exports = __webpack_public_path__ + "img/all-light.f9b2020a.svg";